/** Stripe.js for keyed cards, loaded once from js.stripe.com (never bundled). */

export interface StripeElementsInstance {
  create(type: 'payment', options?: Record<string, unknown>): { mount(selector: string | HTMLElement): void; unmount(): void; on(event: 'ready' | 'change', handler: (event: { complete?: boolean }) => void): void };
}

export interface StripeInstance {
  elements(options: { clientSecret: string; appearance?: Record<string, unknown> }): StripeElementsInstance;
  confirmPayment(options: { elements: StripeElementsInstance; confirmParams: { return_url: string }; redirect?: 'if_required' }): Promise<{ error?: { message?: string }; paymentIntent?: { id: string; status: string } }>;
}

declare global {
  interface Window {
    Stripe?: (publishableKey: string) => StripeInstance;
  }
}

let loading: Promise<void> | null = null;

export function loadStripe(publishableKey: string): Promise<StripeInstance> {
  if (window.Stripe) return Promise.resolve(window.Stripe(publishableKey));
  loading ??= new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject(new Error('Stripe.js failed to load')));
    document.head.appendChild(script);
  });
  return loading.then(() => {
    if (!window.Stripe) throw new Error('Stripe.js did not initialize');
    return window.Stripe(publishableKey);
  });
}
